import React, { useState } from 'react';
import { CreditUsageByLogin } from '../components/usage/CreditUsageByLogin';
import { JobCostInsight } from '../components/usage/JobCostInsight';
import { usageAPI } from '../lib/api';

const TABS = [
  { key: 'login', label: 'By login' },
  { key: 'job', label: 'Cost per hire' },
];

export default function CreditUsagePage() {
  const [view, setView] = useState('login');
  return (
    <div data-testid="credit-usage-page">
      <div className="page-header">
        <h1 className="page-title">Credit Usage</h1>
        <p className="page-subtitle">Absolute AI credit usage across your team — traced through every candidate's resume → assessment → interview journey, and the average credits it takes to make a hire.</p>
      </div>

      <div style={{ display: 'inline-flex', gap: '0.25rem', background: '#F1F5F9', padding: '0.25rem', borderRadius: 10, marginBottom: '1.5rem' }}>
        {TABS.map((t) => (
          <button key={t.key} data-testid={`credit-usage-tab-${t.key}`} onClick={() => setView(t.key)}
            style={{
              border: 'none', cursor: 'pointer', borderRadius: 8, padding: '0.4rem 0.9rem',
              fontSize: '0.8125rem', fontWeight: 700,
              background: view === t.key ? '#fff' : 'transparent',
              color: view === t.key ? '#002A38' : '#64748B',
              boxShadow: view === t.key ? '0 1px 2px rgba(0,0,0,0.06)' : 'none',
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {view === 'login' ? (
        <CreditUsageByLogin
          getReport={(month) => usageAPI.team(month)}
          getTimeline={(rid, month) => usageAPI.teamLoginTimeline(rid, month)}
          intro="Absolute credit usage by login for your team. Expand a login to trace each candidate's journey — resume parse → ranking → assessment → interview questions → video interview — with credits at every step."
        />
      ) : (
        <JobCostInsight
          getReport={(month) => usageAPI.teamByJob(month)}
          intro="Average AI credits it takes to move one candidate from resume upload to hire, per job. Avg credits / hire = total AI credits spent on the job ÷ candidates hired."
        />
      )}
    </div>
  );
}
